import { SPECIAL_CONDITION_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { ISpecialCondition } from "../../shared/interfaces/special-condition/ISpecialCondition";

export const SpecialConditionService = {
  getAll: (params: IPagination) => requests.get(SPECIAL_CONDITION_URL, params),
  create: (params: ISpecialCondition) => requests.post(`${SPECIAL_CONDITION_URL}`, params),
  getSingle: (id: number) => requests.get(`${SPECIAL_CONDITION_URL}/${id}`),
  update: (params: ISpecialCondition, id: number) =>
    requests.put(`${SPECIAL_CONDITION_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${SPECIAL_CONDITION_URL}/${id}`),
};
